module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_15-1bd3f1d937b9c0615b9e7cb6543c73f8.png";